import React, { useContext } from "react";
import Button from "../../uiComponents/Button";
import { ModalContext } from "../../ModalContext";
import { useDispatch } from "react-redux";
import { deleteUser } from "../../../store/actions/user";
const DeleteProfModal = () => {
  const { handleModal } = useContext(ModalContext);
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(deleteUser());
    handleModal();
  };
  return (
    <div>
      <p className="modal_title">
        Are you sure you want to delete your profile?
      </p>
      <div className="modal_btns">
        <Button transparent={true} clickFunction={handleModal}>
          Cancel
        </Button>
        <Button clickFunction={handleClick}>Delete</Button>
      </div>
    </div>
  );
};

export default DeleteProfModal;
